interface PosXY {
    x: number;
    y: number;
}

interface PosTB {
    top: number;
    bottom: number;
}

class ImagesLoader {
    private count: number = 0;
    private onload: () => void;

    public constructor() {

    }

    public onLoad(onload: () => void): void {
        this.onload = onload;
    }

    public loadImage(url: string): HTMLImageElement {
        this.count ++;

        let img: HTMLImageElement = document.createElement('img');

        img.addEventListener('load', () => {
            this.count --;

            if (this.count == 0) {
                if (this.onload) {
                    this.onload();
                }
            }
        });

        img.src = url;

        return img;
    }
}

class Images {
    private $parent: JQuery;
    private player: Player360;

    private step: number;
    private name: string;

    private images: any;
    private loaded: boolean;

    public constructor($parent: JQuery, player: Player360, step: number, name: string) {
        this.$parent = $parent;
        this.player = player;
        this.step = step;
        this.name = name;

        this.images = {};

        this.loaded = false;
    }

    public add(d: number, img: HTMLImageElement): void {
        let $img = $(img);

        $img.appendTo(this.$parent);

        this.images[d] = $img;
    }

    public show(p?: number): void {
        const d = p !== null ? this.player.pToD(p) : null;

        $.each(this.images, (k, $img) => {
            $img.toggleClass('selected', d == parseInt(k));
        });
    }

    private getPathBase(): string {
        return '/theme/images/creator/' + this.name + '/360';
    }

    private getImageUrl(p: number): string {
        const path = this.getPathBase();
        const d = this.player.pToD(p);

        let id = (d + 10000).toString().substr(1);

        return path + '/' + id + '.jpg';
    }

    public load(onload?: () => void): void {
        if (this.loaded) {
            return;
        }

        const size = 360 / this.step;

        let loader = new ImagesLoader();

        loader.onLoad(() => {
            this.loaded = true;

            if (onload) {
                onload();
            }
        });

        for (let i = 0; i < size; i++) {
            const d = i * this.step;
            const p = i / size;

            let img = loader.loadImage(this.getImageUrl(p));

            this.add(d, img);
        }
    }
}

export default class Player360 {
    public static INITALP = 0.60;

    private $el: JQuery
    private $bar: JQuery;
    private $line: JQuery;
    private $tick: JQuery
    private $images: JQuery

    private p: number;
    private step: number;

    private hover: number = 0;

    private images: any;

    private curname: string;

    public constructor($el: JQuery) {
        this.$el = $el;
        this.step = 5;
        this.p = Player360.INITALP;

        this.images = {};

        this.initHtml();
        this.initAnimator();
    }

    private initHtml(): void {
        this.$bar = $('.player360__bar', this.$el);
        this.$line = $('.player360__line', this.$el);
        this.$tick = $('.player360__tick', this.$el);
        this.$images = $('.player360__images', this.$el);

        let $body = $('body');

        let start: PosXY = null;
        let linepos: PosTB = null;

        this.$tick.bind('mousedown', (e) => {
            start = {
                x: e.pageX,
                y: e.pageY
            };

            let boff = this.$line.offset();

            linepos = {
                top: boff.top,
                bottom: boff.top + this.$line.height()
            };

            this.hover++;

            this.updateLayout();
        });

        $body.bind('mousemove', (e) => {
            if (start != null) {
                // let delta = {
                //     x: start.x - e.pageX,
                //     y: start.y - e.pageY,
                // }

                let p = (e.pageY - linepos.top) / (linepos.bottom - linepos.top);

                if (p < 0) {
                    p = 0;
                }

                if (p > 1) {
                    p = 1;
                }

                this.setTickPos(p);
            }
        });

        $body.bind('mouseup', (e) => {
            if (start != null) {
                start = null;

                this.hover--;
                this.updateLayout();
            }
        });

        this.$el.hover(
            () => {
                this.hover++;

                this.updateLayout();
            },

            () => {
                this.hover--;

                this.updateLayout();
            }
        );

        setTimeout(() => {
            this.setTickPos(this.p);
        }, 10);

        this.updateLayout();

        this.$el.addClass('player360--inited');
    }

    public updateLayout(): void {
        this.$el.toggleClass('player360--hover', this.hover > 0);
    }

    private pToIx(p: number): number {
        const d = this.pToD(p);
        const p2 = d / 360;
        const size = 360 / this.step;

        let ix;

        if (p2 == 1) {
            ix = 0;
        } else {
            ix = Math.round(p2 * size);
        }

        return ix;
    }

    private wrapP(p: number): number {
        let p2 = p + 0.25;

        if (p2 < 0) {
            p2 += 1;
        }

        if (p2 >= 1) {
            p2 -= 1;
        }

        return p2;
    }

    public pToD(p: number): number {
        const p2 = this.wrapP(p);

        let d = Math.round(p2 * 360 / this.step) * this.step;

        if (d == 360) {
            d = 0;
        }

        return d;
    }

    private initAnimator(): void {
        let prev: number = null;
        let cur: number = Player360.INITALP;

        setInterval(() => {
            if (this.curname) {
                const delta = (this.p - cur) / 8;

                cur += delta;

                let d = this.pToD(cur);

                if (prev == d) {
                    return;
                }

                this.images[this.curname].show(cur);

                // this.$el.toggleClass('player360--dims', this.p > 0.55 && this.p < 0.7)
                this.$el.addClass('player360--dims')

                prev = d;
            }
        }, 1000 / 30);
    }

    public setTickPos(p: number): void {
        this.p = p;

        const th2 = this.$tick.height() / 2;
        const lh = this.$line.height();
        const tp = th2 / lh;

        if (p < tp) {
            p = tp;
        }

        if (p > 1 - tp) {
            p = 1 - tp;
        }

        this.$tick.css({
            'top': (p * 100) + '%'
        });
    }

    private doShow(name: string): void {
        this.curname = name;

        $.each(this.images, (k, images) => {
            this.images[k].show(this.curname == k ? this.p : null);
        });
    }

    public show(name: string, oncomplete?: () => void): void {
        if (!this.images[name]) {
            this.$el.removeClass('player360--loaded');
            this.$el.addClass('player360--loading');

            let $images = $('<div class="player360__images-list">');
            $images.appendTo(this.$images);

            let images = new Images($images, this, this.step, name);

            this.images[name] = images;

            images.load(() => {
                this.$el.addClass('player360--loaded');
                this.$el.removeClass('player360--loading');

                this.doShow(name);

                if (oncomplete) {
                    oncomplete();
                }
            });
        } else {
            this.doShow(name);

            if (oncomplete) {
                oncomplete();
            }
        }
    }
}
